import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BsModalService } from 'ngx-bootstrap/modal';
import { IBaseLayer } from 'shared';
import {AlertBuilderComponent} from 'shared/components';
import { Utils } from '../classes';

@Injectable()
export class AppService {
  constructor(private http: HttpClient, private modalService: BsModalService) {}

  getBasemaps(): Observable<IBaseLayer[]> {
    return this.http.get<any[]>('/projects/basemaps.json').pipe(
      map(data => data.map(item => Utils.createBaseLayerObject(item))),
      catchError(this.handleError)
    );
  }

  openAlertWindow(text: string, buttonsText: string[], activeButton: number): Observable<number> {
    return new Observable(obs => {
      const bsModalRef = this.modalService.show(AlertBuilderComponent, { class: 'alert-builder-dialog' });
      const component = bsModalRef.content as AlertBuilderComponent;
      component.text = text;
      component.buttons = buttonsText;
      component.activeButton = activeButton;
      component.submit.subscribe((index: number) => {
        obs.next(index);
        bsModalRef.hide();
      });
    });
  }

  private handleError(ex: any) {
    const msg = 'Reguest error:' + ex;
    console.error(msg);
    return observableThrowError(msg);
  }
}
